import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { GET_DBC_URL, GET_DIRECT_BILL_COMM_GEN_REPORT_URL } from 'constants/api';
import { handlePdfDownload } from 'components/CommonUtilityServices/DownloadPdfService';
import { Alert, Box, Button, Col, Row, Select } from 'components/AORedesign';
import useFetchSelectMenuItems from 'hooks/useFetchSelectMenuItems';
import { buildReportRequestBody, getValidationError, toPeriodOption } from './DbcReport.api';

const DbcReportForm = ({ AgencyPicker }) => {
  const [agencyCode, setAgencyCode] = useState('');
  const [period, setPeriod] = useState('');
  const [periodOptions, setPeriodOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useFetchSelectMenuItems(`${GET_DBC_URL}/dates`, ({ data }) => setPeriodOptions(data.map(toPeriodOption)));

  const generateReport = (exportType) => {
    const validationError = getValidationError({ period, agencyCode });
    if (validationError) {
      setError(validationError);
      return;
    }
    // handlePdfDownload owns the loading and error state while the request is in flight.
    handlePdfDownload(
      'POST',
      buildReportRequestBody({ period, agencyCode, exportType }),
      GET_DIRECT_BILL_COMM_GEN_REPORT_URL,
      setLoading,
      setError,
      () => {},
      'newWindow',
    );
  };

  return (
    <>
      {error && (
        <Box mb={2}>
          <Alert message={error} severity="error" />
        </Box>
      )}
      <AgencyPicker agencyCode={agencyCode} onAgencyCodeChange={setAgencyCode} />
      <Box mb={2}>
        <Select
          id="dbc-year"
          labelId="dbc-year-label"
          label="Month/Year"
          name="period"
          menuItems={periodOptions}
          value={period}
          onChange={(e) => setPeriod(e.target.value)}
        />
      </Box>
      <Box mb={4}>
        <Row spacing={2}>
          <Col>
            <Button id="dbc-generate-report-button" variant="contained" color="primary" loading={loading} onClick={() => generateReport('pdf')}>
              Generate Pdf
            </Button>
          </Col>
          <Col>
            <Button id="dbc-generate-excel-report-button" variant="outlined" color="primary" loading={loading} onClick={() => generateReport('excel')}>
              Generate Excel
            </Button>
          </Col>
        </Row>
      </Box>
    </>
  );
};

DbcReportForm.propTypes = {
  AgencyPicker: PropTypes.elementType.isRequired,
};

export default DbcReportForm;
